<div class="pay-page" [class.pay-page--mobile]="isMobileView">
  <header class="pay-head">
    <a
      class="cta cta--ghost"
      role="button"
      tabindex="0"
      (click)="goToCart()"
      (keyup.enter)="goToCart()"
      matTooltip="Back to cart">
      ← Cart
    </a>
    <div class="pay-head__copy">
      <p class="pay-kicker">Secure checkout</p>
      <h1 class="pay-title">Cart checkout</h1>
    </div>
    <div class="cart-timer" *ngIf="cartRemainingTime !== '0' && cartRemainingTime !== ''">
      <mat-icon>av_timer</mat-icon>
      <span>Checkout within <strong>{{ cartRemainingTime }}</strong></span>
    </div>
  </header>

  <div class="pay-grid">
    <section class="pay-panel pay-summary">
      <h2 class="pay-panel__title">Order summary</h2>
      <div class="pay-table-head">
        <span>Seats × listing</span>
        <span>Per seat</span>
        <span>Total</span>
      </div>
      <div class="pay-line" *ngFor="let item of cartDetails">
        <span class="pay-line__name">{{ item.seats.length }} × {{ item.productName }}</span>
        <span class="money">{{ item?.cost | currency }}</span>
        <span class="money">{{ item?.total | currency }}</span>
      </div>
      <div class="pay-totals">
        <div class="pay-totals__row">
          <span>Subtotal</span>
          <strong class="money">{{ cartTotalCost() | currency }}</strong>
        </div>
        <div class="pay-totals__row">
          <span>Taxes</span>
          <strong class="money">{{ cartTaxes() | currency }}</strong>
        </div>
        <div class="pay-totals__row">
          <span>Shipping</span>
          <strong class="money">{{ cartShippingCharges() | currency }}</strong>
        </div>
        <div class="pay-totals__row pay-totals__row--grand">
          <span>Total</span>
          <strong class="money money--total">{{ cartTotalCost() | currency }}</strong>
        </div>
      </div>
    </section>

    <div class="pay-stack">
      <section class="pay-panel" *ngIf="loggedUser && loggedUser.id">
        <h2 class="pay-panel__title">
          <img src="assets/Images/lucky-bucks-icon-1.png" alt="" class="lucky-bucks-mark" />
          Lucky Bucks wallet
        </h2>
        <p class="pay-muted" *ngIf="isLoadingWallet">Loading wallet balance…</p>
        <ng-container *ngIf="!isLoadingWallet">
          <div class="wallet-card">
            <img src="assets/Images/lucky-bucks-icon-1.png" alt="Lucky Bucks" class="wallet-card__icon" />
            <div>
              <span>Available balance</span>
              <strong class="money money--dark">{{ walletBalance | currency }}</strong>
            </div>
          </div>
          <mat-checkbox
            *ngIf="walletBalance > 0"
            [(ngModel)]="useWallet"
            (change)="onUseWalletChange()"
            class="pay-check">
            Use Lucky Bucks for this purchase
          </mat-checkbox>
          <p class="pay-note" *ngIf="walletBalance === 0">
            You don’t have Lucky Bucks yet. Owners can add them from the owner portal.
          </p>
          <div class="wallet-apply" *ngIf="useWallet && walletAmountToUse > 0">
            <span>Wallet payment</span>
            <strong class="money">{{ walletAmountToUse | currency }}</strong>
            <p *ngIf="getRemainingAmount() > 0">
              Remaining {{ getRemainingAmount() | currency }} will be charged to your card.
            </p>
            <p class="wallet-apply__full" *ngIf="getRemainingAmount() === 0">
              Full payment from wallet — no card needed.
            </p>
          </div>
        </ng-container>
      </section>

      <section class="pay-panel">
        <div class="pay-panel__row">
          <h2 class="pay-panel__title">Card details</h2>
          <mat-checkbox [(ngModel)]="card.isSaveCardDetails" class="pay-check">Save card to profile</mat-checkbox>
        </div>

        <label class="pay-field">
          <span>Card number</span>
          <input
            type="text"
            class="pay-input"
            aria-label="Card Number"
            appFormatCreditCard
            placeholder="0000-0000-0000-0000"
            id="cardNumber"
            minlength="19"
            maxlength="19">
        </label>

        <div class="pay-fields">
          <label class="pay-field">
            <span>Expiry month</span>
            <select class="pay-input" aria-label="Card Expiry Month" [(ngModel)]="card.cardExpirationMonth">
              <option selected value="0">Month</option>
              <option value="{{ month.month }}" *ngFor="let month of Months">{{ month.name }}</option>
            </select>
          </label>
          <label class="pay-field">
            <span>Expiry year</span>
            <select class="pay-input" aria-label="Card Expiry Year" [(ngModel)]="card.cardExpirationYear">
              <option selected value="0">Year</option>
              <option value="{{ year }}" *ngFor="let year of Years">{{ year }}</option>
            </select>
          </label>
          <label class="pay-field">
            <span>CVV</span>
            <input
              type="text"
              class="pay-input"
              placeholder="CVV"
              aria-label="CVV Number"
              [(ngModel)]="card.cardCvv"
              minlength="3"
              maxlength="4"
              (input)="onCvvEntry('new')"
              id="cvvNumber">
          </label>
        </div>

        <label class="pay-field">
          <span>Card holder name</span>
          <input
            type="text"
            class="pay-input"
            placeholder="Name on card"
            aria-label="Card Holder Name"
            [(ngModel)]="card.cardOwnerName"
            maxlength="200">
        </label>

        <mat-checkbox [(ngModel)]="card.isTermsConditionAccepted" class="pay-check">
          I confirm that I understand I am purchasing these products, and I have read the
          <strong>Terms &amp; Conditions</strong>.
        </mat-checkbox>

        <a
          class="cta cta--gold pay-submit"
          role="button"
          tabindex="0"
          [class.is-disabled]="(!checkCardFormValidation() && getRemainingAmount() > 0) || cartTotalCost() === 0"
          (click)="onMakePayment()"
          (keyup.enter)="onMakePayment()">
          <span *ngIf="useWallet && getRemainingAmount() === 0">
            Pay with wallet ({{ walletAmountToUse | currency }})
          </span>
          <span *ngIf="useWallet && getRemainingAmount() > 0">
            Pay {{ getRemainingAmount() | currency }} now
            <small>({{ walletAmountToUse | currency }} from wallet)</small>
          </span>
          <span *ngIf="!useWallet">
            Pay {{ cartTotalCost() | currency }} now
          </span>
        </a>

        <div
          class="saved-cards"
          *ngIf="savedCards.length > 0 && ((useWallet && getRemainingAmount() > 0) || !useWallet)">
          <h3 class="pay-panel__title pay-panel__title--sub">Saved cards</h3>
          <mat-radio-group aria-label="Select Card To Pay" class="saved-list">
            <div
              class="saved-item"
              *ngFor="let card of savedCards"
              [class.is-selected]="selectedSavedActiveCard === card.id">
              <div class="saved-row">
                <mat-radio-button
                  value="{{ card.id }}"
                  (change)="onChangeSavedCard(card.id)">
                </mat-radio-button>
                <span class="saved-brand" [attr.data-brand]="cardBrand(card.cardNumber)">
                  {{ cardBrand(card.cardNumber) }}
                </span>
                <div class="saved-main">
                  <p class="saved-main__title">
                    <strong>{{ cardBrand(card.cardNumber) }}</strong>
                    ending in {{ cardLast4(card.cardNumber) }}
                  </p>
                  <p class="saved-main__name">{{ card.cardHolderName }}</p>
                </div>
                <div class="saved-exp">
                  <span>Expires</span>
                  <strong>{{ formatCardExpiry(card.cardExpiryMonth, card.cardExpiryYear) }}</strong>
                </div>
                <a
                  class="saved-row__delete"
                  role="button"
                  tabindex="0"
                  matTooltip="Delete card details"
                  (click)="onDeleteSavedCardDetail(card.id); $event.stopPropagation()"
                  (keyup.enter)="onDeleteSavedCardDetail(card.id)">
                  Delete
                </a>
              </div>
              <div class="saved-pay" *ngIf="selectedSavedActiveCard === card.id">
                <label class="saved-pay__cvv">
                  <span>CVV</span>
                  <input
                    type="text"
                    class="pay-input pay-input--cvv"
                    placeholder="CVV"
                    aria-label="CVV Number"
                    [(ngModel)]="savedCardCvv"
                    minlength="3"
                    maxlength="4"
                    (input)="onCvvEntry('savedCard')"
                    id="cvvNumberSavedCard">
                </label>
                <a
                  class="cta cta--gold saved-pay__cta"
                  role="button"
                  tabindex="0"
                  [class.is-disabled]="(savedCardCvv === undefined || savedCardCvv.length < 3) && (!useWallet || getRemainingAmount() > 0)"
                  (click)="onMakePaymentThroughSavedCard(card)"
                  (keyup.enter)="onMakePaymentThroughSavedCard(card)">
                  <span *ngIf="useWallet && getRemainingAmount() === 0">
                    Pay with wallet ({{ walletAmountToUse | currency }})
                  </span>
                  <span *ngIf="useWallet && getRemainingAmount() > 0">
                    Pay {{ getRemainingAmount() | currency }}
                  </span>
                  <span *ngIf="!useWallet">
                    Pay {{ cartTotalCost() | currency }}
                  </span>
                </a>
              </div>
            </div>
          </mat-radio-group>
        </div>
      </section>
    </div>
  </div>
</div>
